<section style="text-align: center;" *ngIf="invoices.length == 0">
    <h3>Sin Facturas recibidas</h3>
</section>
<section [hidden]="invoices.length == 0">
    <div class="overflow-table">
        <table mat-table matSort (matSortChange)="changeSorting($event)" [dataSource]="dataSource">
            <ng-container matColumnDef="folio">
                <th mat-header-cell mat-sort-header="Folio" *matHeaderCellDef class="th-header">
                    Folio
                </th>
                <td mat-cell *matCellDef="let element">
                    <h6>{{ element.folio }}</h6>
                </td>
            </ng-container>
            <ng-container matColumnDef="fechaDocto">
                <th mat-header-cell mat-sort-header="FechaDocto" *matHeaderCellDef class="th-header">
                    Fecha Docto.
                </th>
                <td mat-cell *matCellDef="let element">
                    <h6>{{ element.fechaDocto | date : 'dd-MM-yyyy'}}</h6>
                </td>
            </ng-container>
            <ng-container matColumnDef="montoTotal">
                <th mat-header-cell *matHeaderCellDef class="th-header">
                    Monto Total
                </th>
                <td mat-cell *matCellDef="let element">
                    <h6>{{ element.montoTotal | currency: 'CLP'}}</h6>
                </td>
            </ng-container>
            <ng-container matColumnDef="fechaCesion">
                <th mat-header-cell mat-sort-header="FechaCesion" *matHeaderCellDef class="th-header">
                    Fecha Cesión
                </th>
                <td mat-cell *matCellDef="let element">
                    <h6>{{ element.fechaCesion | date : 'dd-MM-yyyy'}}</h6>
                </td>
            </ng-container>
            <ng-container matColumnDef="montoCesion">
                <th mat-header-cell *matHeaderCellDef class="th-header">
                    Monto Cesión
                </th>
                <td mat-cell *matCellDef="let element">
                    <h6>{{element.montoCesion | currency : 'CLP'}}</h6>
                </td>
            </ng-container>
            <ng-container matColumnDef="proveedorRut">
                <th mat-header-cell mat-sort-header="ProveedorCompanyId" *matHeaderCellDef class="th-header">
                    RUT Proveedor
                </th>
                <td mat-cell *matCellDef="let element">
                    <h6>{{element.proveedorRut}}</h6>
                </td>
            </ng-container>
            <ng-container matColumnDef="proveedorName">
                <th mat-header-cell mat-sort-header="ProveedorName" *matHeaderCellDef class="th-header">
                    Nombre Proveedor
                </th>
                <td mat-cell *matCellDef="let element">
                    <h6>{{element.proveedorName}}</h6>
                </td>
            </ng-container>
            <ng-container matColumnDef="clienteRut">
                <th mat-header-cell mat-sort-header="ClienteCompanyId" *matHeaderCellDef class="th-header">
                    RUT Deudor
                </th>
                <td mat-cell *matCellDef="let element">
                    <h6>{{element.clienteRut}}</h6>
                </td>
            </ng-container>
            <ng-container matColumnDef="clienteName">
                <th mat-header-cell mat-sort-header="ClienteName" *matHeaderCellDef class="th-header">
                    Nombre Deudor
                </th>
                <td mat-cell *matCellDef="let element">
                    <h6>{{element.clienteName}}</h6>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columns"></tr>
            <tr mat-row *matRowDef="let row; columns: columns"></tr>
        </table>
    </div>
    <mat-paginator (page)="changePagination($event)" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
</section>